import { render } from "./LogoutBox.vue?vue&type=template&id=4fa49e71&scoped=true"
import script from "./LogoutBox.vue?vue&type=script&lang=js"
export * from "./LogoutBox.vue?vue&type=script&lang=js"

import "./LogoutBox.vue?vue&type=style&index=0&id=4fa49e71&scoped=true&lang=css"

import exportComponent from "D:\\xampp\\htdocs\\chandigarh\\kanda\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa49e71"]])

export default __exports__